module.exports = __webpack_public_path__ + "img/DocumentExplorer-dark.3b2ac108.svg";